module.exports = __webpack_public_path__ + "img/depmap_svg_V33.077634ae.svg";